import axios from 'axios';

class CartQf {
  constructor() {
    this.cart = window.QF.cart;
    this.previousCartCount = 0;

    this.endpoints = {
      add: {
        url: 'cart/add.js',
        method: 'post'
      },
      get: {
        url: 'cart.js',
        method: 'get'
      },
      update: {
        url: 'cart/update.js',
        method: 'post'
      },
      change: {
        url: 'cart/change.js',
        method: 'post'
      },
      clear: {
        url: 'cart/clear.js',
        method: 'post'
      }
    }

    this.selectors = {
      cartDrawerContainer: '[cart-drawer-container]',
      cartTabs: '[side-cart-tab]',
      cartContent: '[side-cart-form]',
      cartFormTab: '[side-cart-inner]',
      savedCartTab: '[saved-cart-tab]',
      sideCartButtonEls : '[cart-buttons]',
      sideCartRecommendations: '[side-cart-recommendations]',
      sideCartRecommendationsSection: '[side-cart-recommendations-section]',
      sideCartRecommendationsContainer: '[side-cart-recommended-container]',
      cartRecommendations: '[cart-recommendations]',
      cartRecommendationsSlider: '[theme-settings-recommendations]',
      cartItemsContainer: '[cart-items-container]',
      cartCount: '[cart-count]',
      openSideCartTrigger: '[open-side-cart]',
      sideCartInner: '[side-cart-inner]',
      cartContainer: '[cart-container]',
      sideCartTotal: '[side-cart-total]',
      sideCartItemsCount: '[side-cart-items-count]',
      checkoutButton: '[side-checkout-total]',
      expressCheckoutTrigger: 'express-checkout-trigger',
      expressCheckoutSection: 'express-checkout-section',
    }
  }

  dispatchEvent(event_name, includeCart) {
    let contents = null
    if (includeCart) {
      contents = {
        detail: {
          cart: this.cart,
        },
      }
    }
    window.dispatchEvent(new CustomEvent(event_name, contents))
  }

  add(data) {
    return new Promise((resolve, reject) => {
      this.request('add', data).then(({ data }) => {
        this.mergeWithCurrentCart(data)
        this.reRenderCartCounter()
        this.dispatchEvent("cart_changed", true)
        this.dispatchEvent("item_added", true)
        resolve(this.cart)
      }).catch((error) => {
        reject(error)
      })
    });
  }

  get() {
    return new Promise((resolve, reject) => {
      this.request('get').then((response) => {
        this.cart = response.data;
        resolve(this.cart);
      }).catch((error) => {
        reject(error)
      })
    });
  }

  update(data) {
    return new Promise((resolve, reject) => {
      this.request('update', data).then(({ data }) => {
        this.cart = data;
        this.dispatchEvent("cart_changed", true)
        resolve(this.cart)
        this.reRenderCartCounter();
      }).catch((error) => {
        reject(error)
      })
    });
  }

  remove(variant_id) {
    return new Promise((resolve, reject) => {
      let updates = {
        updates: {
          [variant_id]: 0,
        }
      }
      this.request('update', updates).then(({ data }) => {
        this.cart = data;
        this.dispatchEvent("cart_changed", true)
        this.dispatchEvent("item_removed", true)
        resolve(this.cart)
        this.reRenderCartCounter();
      }).catch((error) => {
        reject(error)
      })
    })
  }

  removeGWP(variant_id){
    return new Promise((resolve, reject) => {
      variant_id.forEach((item) => {
        let updates = {
          updates: {
            
            [item]: 0,
            
          }
        }
      })
      this.request('update', updates).then(({ data }) => {
        this.cart = data;
        this.dispatchEvent("cart_changed", true)
        this.dispatchEvent("item_removed", true)
        resolve(this.cart)
        this.reRenderCartCounter();
      }).catch((error) => {
        reject(error)
      })
    })
  }

  clear() {
    return new Promise((resolve, reject) => {
      this.request('clear').then(({ data }) => {
        this.cart = data
        this.dispatchEvent("cart_changed", true)
        this.dispatchEvent("cart_cleared", true)
        resolve(this.cart)
      }).catch((error) => {
        reject(error)
      })
    });
  }

  async request(key, data) {
    return new Promise((resolve, reject) => {
      const url = window.Shopify.routes.root + this.endpoints[key].url;
      const method = this.endpoints[key].method;
      axios({
        method,
        url,
        data,
        headers: {
          'Content-Type': 'application/json'
        },
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        if (error.response) {
          // Request made and server responded
          reject(error.response.data);
        } else if (error.request) {
          // The request was made but no response was received
          reject(error.request)
        } else {
          // Something happened in setting up the request that triggered an Error
          reject(error.message)
        }
      })
    })
  }

  removeBundle(bundle) {
    let clearUpdates = {
      updates: {}
    }
    const updates = bundle.reduce((acc, value)=>{
      acc.updates[value] = 0;
      return acc
    }, clearUpdates)
    return this.request('update', updates);
    
  }

  mergeWithCurrentCart(data) {
    if (data.items) {
      data.items.forEach((item) => {
        let index = this.cart.items.findIndex(e => e.id === item.id);
        if (index > -1) {
          this.cart.items[index] = item;
        } else {
          this.cart.items.push(item)
        }
      });
    }
  }

  openSideCart() {
    this.reRenderSideCart(() => {
      let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
      if (sideCartContainer) {
        sideCartContainer.classList.add("open");
        document.body.classList.add("fixed");
        sideCartContainer.style.height = window.innerHeight + "px";
        window.addEventListener("resize", () => {
          sideCartContainer.style.height = window.innerHeight + "px";
        })
        this.dispatchEvent("side_cart_closed", false)
      }
    });
  }

  closeSideCart() {
    let sideCartContainer = document.querySelector(this.selectors.cartDrawerContainer);
    let recommendations_container = document.querySelector(this.selectors.sideCartRecommendations);
    let slideOut = recommendations_container.querySelector('.recommendation-slide-out');
    if (slideOut) {
      slideOut.classList.remove('loaded');
    }
    if (sideCartContainer) {
      sideCartContainer.classList.remove("open");
      document.body.classList.remove("fixed");
      this.dispatchEvent("side_cart_closed", false)
    }
  }

  // Calls the seciton rendering API to render the v2-side-cart section (with refference to the cart page) and inserts the section html into the side cart
  /* async reRenderSideCart(successCallback = null) {
    await axios
      .get(" /cart?sections=v2-side-cart", {})
      .then((response) => {
        // Success
        let html = response.data["v2-side-cart"];
        let side_cart_inner = document.querySelector(
          "#cart-drawer-container .inner"
        );

        if (side_cart_inner && html) {
          side_cart_inner.innerHTML = html;

          // Change free delivery status
          let free_delivery_el = document.querySelector('.free-delivery-status');
          let free_delivery_trigger = free_delivery_el.dataset.freeDelivery;
          // console.log("🚀 ~ file: side_cart_functions.js:59 ~ free_delivery_trigger", free_delivery_trigger)
          let cart_total;
          if(document.querySelector('#cart-drawer .sub-total')){
            cart_total = document.querySelector('#cart-drawer .sub-total').dataset.subTotal / 100;
          }

          if (!free_delivery_trigger) {
            free_delivery_el.style.display = 'none';
          } else if (cart_total < free_delivery_trigger) {
            let spend_more = free_delivery_trigger - cart_total;
            spend_more = spend_more.toFixed(2);
            free_delivery_el.innerHTML = `£${spend_more} away from free delivery`;
          } else {
            free_delivery_el.innerHTML = `Yay! You've qualified for free delivery! 🎉`;
          }

          let first_cart_item = side_cart_inner.querySelector('.item');

          if (first_cart_item) {
            first_cart_item = first_cart_item.dataset.productId;
          }

          // Get recommended products based on first item in side cart
          if (first_cart_item) {
            const productRecommendationsSection = document.querySelector('.cart-recommendations');
            const section_id = productRecommendationsSection.dataset.sectionId;

            // axios.get(`/recommendations/products.json?product_id=${first_cart_item}&limit=5`)
            axios.get(`/recommendations/products?section_id=${section_id}&product_id=${first_cart_item}&limit=5`, {})
              .then((response) => {
                const text = response.data;
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.cart-recommendations');
                if (recommendations && recommendations.innerHTML.trim().length) {
                  productRecommendationsSection.innerHTML = recommendations.innerHTML;
                  let product_links = productRecommendationsSection.querySelectorAll('.product-link');
                  product_links.forEach((product_link) => {
                    product_link.innerHTML = "View"
                  })

                  const swiper_side_cart_recommended = new window.swiper('.side-cart-recommendations-slider', {
                    slidesPerView: 2.4,
                    spaceBetween: 10,
                    breakpoints: {
                      1200: {
                        slidesPerView: 3.2
                      }
                    },
                    lazy: {
                      enabled: true,
                      checkInView: false,
                      loadOnTransitionStart: true,
                      loadPrevNext: true,
                      loadPrevNextAmount: 1
                    },
                  });

                }
              })
              .catch((error) => {
                window.log(error);
              })
          }

          this.cartRenderedEvent(response, html)

          if (successCallback) {
            successCallback();
          }
        }
      })
      .catch((error) => {
        window.log("Error:", error);
      })
  } */

  async reRenderSideCart(successCallback = null) {
    // UPDATE CART COUNT
    const updateCartCount = (count) => {
      let cart_count = 0;
      const cartCountEl = document.querySelectorAll(this.selectors.cartCount);

      // Only proceed if cart count elements exist
      if (cartCountEl.length === 0) return;

      // Calculate cart count excluding addon products
      if (this.cart && this.cart.items) {
        this.cart.items.forEach(el => {
          if (el.properties && el.properties['Group Type'] == 'Add-on') {
          } else {
            cart_count += el.quantity;
          }
        });
      }

      const quantityChanged = cart_count !== this.previousCartCount;

      cartCountEl.forEach(count_el => {
        if (cart_count == 0) {
          count_el.classList.add('empty-cart');
        } else {
          count_el.classList.remove('empty-cart');
        }
        
        if (quantityChanged && cart_count > 0) {
          count_el.classList.remove('grow-animation');
          void count_el.offsetWidth;

          count_el.classList.add('grow-animation');
          
          setTimeout(() => {
            count_el.classList.remove('grow-animation');
          }, 600);
        }
        
        count_el.innerHTML = cart_count;
      });

      this.previousCartCount = cart_count;
    }

    try {
      const response = await fetch(window.Shopify.routes.root + "cart?sections=v3-side-cart");
      if (!response.ok) {
        throw new Error("Error: " + response.status);
      }
      const data = await response.json();
      const cart_html = data["v3-side-cart"];
      const side_cart_inner = document.querySelector(this.selectors.sideCartInner);
      const side_cart_total = document.querySelector(this.selectors.sideCartTotal);
      const side_cart_total_button = document.querySelector(this.selectors.checkoutButton);
      const side_cart_items_count = document.querySelector(this.selectors.sideCartItemsCount);
      const recommendations_container = document.querySelector(this.selectors.sideCartRecommendations);
      const free_delivery_status = document.querySelector('[free-delivery-status]');

      const newHtml = new DOMParser().parseFromString(cart_html, 'text/html');
      const newCartItems = newHtml.querySelector('[cart-items]');
      const newCartTotal = newHtml.querySelector(this.selectors.sideCartTotal);
      const newCartItemsCount = newHtml.querySelector(this.selectors.sideCartItemsCount);
      const newCartCount = newHtml.querySelector(this.selectors.sideCartInner).getAttribute('data-items-count');
      const newFreeDeliveryStatus = newHtml.querySelector('[free-delivery-status]');
      const new_side_cart_total_button = newHtml.querySelector(this.selectors.checkoutButton);

      if (newCartCount) {
        side_cart_inner.setAttribute('data-items-count', newCartCount);
      }

      const quickAddMobile = document.querySelector('.quick-add-mobile.visible');

      if (quickAddMobile) {
        quickAddMobile.classList.remove('visible');
      }

      if (newFreeDeliveryStatus && free_delivery_status) {
        const newDeliveryStatusValue = newFreeDeliveryStatus.getAttribute('data-show-free-delivery');
        const deliveryStatusValue = free_delivery_status.getAttribute('data-show-free-delivery');

        if (deliveryStatusValue !== newDeliveryStatusValue) {
          free_delivery_status.setAttribute('data-show-free-delivery', newDeliveryStatusValue);
        }

        free_delivery_status.innerHTML = newFreeDeliveryStatus.innerHTML;
      }

      if (newCartItems) {
        if (side_cart_inner) {
          side_cart_inner.innerHTML = newCartItems.innerHTML;
        }
      } else if (side_cart_inner) {
        const newCartInner = newHtml.querySelector(this.selectors.sideCartInner);
        side_cart_inner.innerHTML = newCartInner.innerHTML;
      }

      if (newCartItemsCount && side_cart_items_count) {
        side_cart_items_count.innerHTML = newCartItemsCount.innerHTML;
      }

      if (side_cart_total && newCartTotal) {
        side_cart_total.innerHTML = newCartTotal.innerHTML;
      } else {
        console.warn("Side cart total element not found in the DOM or fetched HTML.");
      }

      if(new_side_cart_total_button && side_cart_total_button){
        side_cart_total_button.innerHTML = new_side_cart_total_button.innerHTML;
      }

      if (side_cart_inner && cart_html) {
        updateCartCount(newCartCount);

        this.cartRenderedEvent(response, cart_html);
        this.expressButtonsContainer();

        console.log(newCartCount);

        if(newCartCount > 0) {
        // Fetch and render recommendations
        fetch(window.Shopify.routes.root + "cart?sections=tp-recommendations-slide-out")
          .then(res => res.json())
          .then(data => {
            var recommendations_html = data["tp-recommendations-slide-out"];

            if (recommendations_container && recommendations_html) {
                const parsedHtml = new DOMParser().parseFromString(recommendations_html, 'text/html');
                const newRecommendations = parsedHtml.querySelector('.recommendation-slide-out');
                
                if (newRecommendations && newRecommendations.innerHTML.includes('recommendation-slide-out__item')) {
                  recommendations_container.querySelector('.recommendation-slide-out').innerHTML = newRecommendations.innerHTML;

                // Reinitialize Yotpo widgets for reviews
                if (window.yotpo) {
                  window.yotpo.refreshWidgets();
                }

                if (window.initQuickView) {
                  window.initQuickView();
                }

                const slideOut = recommendations_container.querySelector('.recommendation-slide-out');
                if (slideOut) {
                  slideOut.classList.add('loaded');
                } else {
                  console.log("Slide out element not found");
                }

                // Init recommendations slide-out Swiper (arrows + progress bar)
                const recommendationSwiperEl = recommendations_container.querySelector('.recommendation-slide-out-swiper');
                if (recommendationSwiperEl && typeof window.swiper === 'function' && recommendationSwiperEl.querySelectorAll('.swiper-slide').length > 0) {
                  new window.swiper('.recommendation-slide-out-swiper', {
                    slidesPerView: 2,
                    spaceBetween: 10,
                    breakpoints: {
                      768: { slidesPerView: 20 },
                      1199: { slidesPerView: 4, spaceBetween: 30 }
                    },
                    pagination: {
                      el: '.recommendation-slide-out .swiper-pagination',
                      type: 'progressbar'
                    },
                    lazy: {
                      enabled: true,
                      loadPrevNext: true,
                      loadPrevNextAmount: 1
                    }
                  });
                }
              } else {
                const slideOut = recommendations_container.querySelector('.recommendation-slide-out');
                if (slideOut) {
                  slideOut.classList.remove('loaded');
                }
              }
            }
          })
          .catch(err => console.log("Recommendations fetch error:", err));
        } else {
          const slideOut = recommendations_container.querySelector('.recommendation-slide-out');
          if (slideOut) {
            slideOut.classList.remove('loaded');
          }
        }

        if (successCallback) {
          successCallback();
        }

        // close the mobile menu if open
        const mobileMenuOpen = document.querySelector('.mobile-menu-outer-wrapper.active');
        const mobileControl = document.querySelector('.mobile-control');
        const predictiveSearchMobile = document.querySelector('.predictive-search-form.mobile');
        if (mobileMenuOpen && mobileControl) {
          mobileMenuOpen.classList.remove('active');
          mobileControl.classList.remove('active');
          if (predictiveSearchMobile) {
            predictiveSearchMobile.style.display = 'flex';
          }
        }
      } else {
        if (successCallback) {
          successCallback();
        }
      }
    } catch (error) {
      console.log("Error:", error);
      if (successCallback) {
        successCallback();
      }
    }
  }

  reRenderCart() {
    axios
      .get(" /cart?sections=cart-qf", {})
      .then((response) =>{
        let html = response.data["cart-qf"];
        let formattedHtml = new DOMParser().parseFromString(response.data["cart-qf"], "text/html");
        if (formattedHtml.querySelector('.is-empty-container') ){
          document.querySelector(`#cart-container`).innerHTML = formattedHtml.querySelector(`#cart-container`).innerHTML
        }
        let delivery_form = formattedHtml.querySelector('.cart__sidebar');
        let cart_items = formattedHtml.querySelector(".items-wrapper .items").innerHTML; 
        let cart_inner = document.querySelector("#cart-container .items-wrapper .items")

        if (cart_inner && cart_items) {
          cart_inner.innerHTML = cart_items;
          this.cartRenderedEvent(response, html);
          this.reRenderDeliveryForm(delivery_form);
        }
      })
      .catch(function (error) {
        window.log("Error:", error);
      })
  }
  
  cartRenderedEvent(response, html) {
    window.dispatchEvent(new CustomEvent("cart_rendered", {
      detail: {
        response: response,
        html: html,
      },
    }));
  }
  
  reRenderDeliveryForm(form) {
    const subtotalPrice = document.querySelector('.cart__sidebar-subtotal [js-cart="subtotal"]')
    const totalPrice = document.querySelector('.cart__total [js-cart="total"]')
    const totalPriceSpan = document.querySelector('.cart__total [js-cart="total"] #revy-cart-subtotal-price')

    const formSubtotalPrice = form.querySelector('.cart__sidebar-subtotal [js-cart="subtotal"]')
    const formTotalPrice = form.querySelector('.cart__total [js-cart="total"]')
    const formTotalPriceSpan = form.querySelector('.cart__total [js-cart="total"] #revy-cart-subtotal-price')
    const formSubtotalPriceDataPrice = formSubtotalPrice.getAttribute('data-price')
    const formTotalPriceDataPrice = formTotalPrice.getAttribute('data-price')
    // Subtotal
    subtotalPrice.setAttribute('data-price', formSubtotalPriceDataPrice)
    subtotalPrice.textContent = formSubtotalPrice.textContent

    // Total
    totalPrice.setAttribute('data-price', formTotalPriceDataPrice);
    totalPriceSpan.textContent = formTotalPriceSpan.textContent;

    const change_event = new Event('update::price');
    document.dispatchEvent(change_event);
  }

  reRenderCartCounter() {
    let cartCounter = document.querySelectorAll('[js-ajax-cart="cartCounter"]');

    this.get()
      .then(function (response) {
        let cartCount = document.querySelectorAll(".basket .site-header__badge");
        let counter = 0;
        let items = response.items;

        items.forEach(el => {
          if(el.properties['Group Type'] == 'Add-on'){}
          else{
            counter += el.quantity;
          }
        })
        if(counter > 0){
          cartCount.forEach((count) => {
            count.innerHTML = counter;
            count.classList.remove('is-hidden')
          })
        }else{
          cartCount.forEach((count) => {
            count.classList.add('is-hidden')
          })
        }
      })
      .catch(function (error) {
        window.log("Error:", error);
      })
  }

  expressButtonsContainer() {
    const expressCheckoutTrigger = document.getElementById(this.selectors.expressCheckoutTrigger);
    const expressCheckoutSection = document.getElementById(this.selectors.expressCheckoutSection);

    if (expressCheckoutTrigger && expressCheckoutSection) {
      // Show the express checkout section
      expressCheckoutTrigger.addEventListener("click", function () {
        const isSectionHidden = expressCheckoutSection.classList.contains("hidden");
        const openText = expressCheckoutTrigger.getAttribute("data-open-express-checkout-options");
        const closeText = expressCheckoutTrigger.getAttribute("data-close-express-checkout-options");

        if (isSectionHidden) {
          expressCheckoutTrigger.innerText = closeText;
          expressCheckoutTrigger.classList.add("active");
          expressCheckoutSection.classList.remove("hidden");

        } else {
          expressCheckoutTrigger.innerText = openText;
          expressCheckoutTrigger.classList.remove("active");
          expressCheckoutSection.classList.add("hidden");
        }
      });

      // Close express checkout if user clicks outside the section
      document.addEventListener("click", function (event) {
        const openText = expressCheckoutTrigger.getAttribute("data-open-express-checkout-options");

          if (
              !expressCheckoutSection.contains(event.target) && // Click outside the express checkout section
              !expressCheckoutTrigger.contains(event.target)   // And not on the trigger
          ) {
            if (!expressCheckoutSection.classList.contains("hidden")) {
              expressCheckoutSection.classList.add("hidden");
              expressCheckoutTrigger.innerText = openText;
            }

            const cartDetailsEl = document.querySelector('.cart-details');
            const recommendationsEl = document.querySelector('[cart-recommendations]');

            if (recommendationsEl && cartDetailsEl) {
              const cartDetailsHeight = cartDetailsEl.offsetHeight;
              recommendationsEl.style.bottom = `${cartDetailsHeight}px`;
            }
          }
      });
    }
  }
}

// export default new CartQf();
window.CartQf = CartQf;